import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

/**
 * GuestRoute - For routes that should only be accessible to non-authenticated users
 * Redirects authenticated users to home page
 * Prevents flashing of login/signup pages when already logged in
 */
const GuestRoute = ({ children }) => {
  const { user, loading, isInitialized } = useSelector((state) => state.auth);
  const token = localStorage.getItem("token");

  // Show loading spinner while auth state is being determined
  if (!isInitialized || loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  // If user is authenticated, redirect to home
  if (token && user) {
    return <Navigate to="/" replace />;
  }

  // User is not authenticated, show guest route (login/signup)
  return children;
};

export default GuestRoute;
